export default __webpack_public_path__ + "static/media/about_me_1.50a912f2.jpg";